module.exports = __webpack_public_path__ + "static/media/gryphon-house-exterior-entrance-closeup.732683d7.jpg";